import type { GameLocale } from "../i18n/types";

export interface GameStats {
  gamesWon: number;
  gamesPlayed: number;
  currentStreak: number;
  maxStreak: number;
  winPercentage: number;
}

const statsKey = (locale: GameLocale) =>
  locale === "no" ? "wordle-stats-no" : "dansk-wordle-stats";

export const getStats = (locale: GameLocale): GameStats => {
  const stats = localStorage.getItem(statsKey(locale));
  if (stats) {
    return JSON.parse(stats);
  }

  return {
    gamesWon: 0,
    gamesPlayed: 0,
    currentStreak: 0,
    maxStreak: 0,
    winPercentage: 0,
  };
};

export const saveStats = (stats: GameStats, locale: GameLocale) => {
  localStorage.setItem(statsKey(locale), JSON.stringify(stats));
};

export const updateStats = (won: boolean, locale: GameLocale) => {
  const stats = getStats(locale);

  stats.gamesPlayed += 1;

  if (won) {
    stats.gamesWon += 1;
    stats.currentStreak += 1;
    if (stats.currentStreak > stats.maxStreak) {
      stats.maxStreak = stats.currentStreak;
    }
  } else {
    stats.currentStreak = 0;
  }

  stats.winPercentage = Math.round((stats.gamesWon / stats.gamesPlayed) * 100);

  saveStats(stats, locale);
  return stats;
};
